import { render } from "./QuestionList.vue?vue&type=template&id=509924b8"
import script from "./QuestionList.vue?vue&type=script&lang=ts"
export * from "./QuestionList.vue?vue&type=script&lang=ts"
script.render = render

export default script